import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MomentModule } from 'angular2-moment';
import { NgSlimScrollModule } from "../../../node_modules/ngx-slimscroll/src/ngx-slimscroll/module/ngx-slimscroll.module";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TooltipModule } from 'ngx-bootstrap';


import { BrightServeModule } from "app/brightserve/brightserve.module";
import { AuthGuard } from "app/brightserve/auth-guard";
import { SharedModule } from "app/shared/shared.module";

import { ReferenceComponent } from 'app/library/reference.component';

const LibraryRoutes: Routes = [
    { path: 'library/reference', component: ReferenceComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [
      CommonModule,
      FormsModule,
      RouterModule.forChild(LibraryRoutes),
      NgbModule,
      MomentModule,
      BrightServeModule,
      SharedModule,
      NgSlimScrollModule,
      InfiniteScrollModule,
      TooltipModule.forRoot()
  ],
  declarations: [
      ReferenceComponent
  ]
})
export class ReferenceLibraryModule { }



// WEBPACK FOOTER //
// ./src/app/library/reference-library.module.ts